(function ($) {
    $(document).ready(function () {
        var window_width = $(window).width();

        if ($("html").hasClass("ua-mobile")) {
            $("body .cards-with-icon .grid-outer .column-wrap .content-wrap .content").unbind().click(function () {
                if ($("body .cards-with-icon .grid-outer .column-wrap .content-wrap .content").hasClass("show-content")) {
                    $("body .cards-with-icon .grid-outer .column-wrap .content-wrap .content").removeClass("show-content");
                    $("body .cards-with-icon .grid-outer .column-wrap .content-wrap").css({'z-index': '0'});

                } else {
                    $(this).toggleClass("show-content");
                    $(this).parent('.content-wrap').css({'position': 'relative;', 'z-index': '99'});
                }
            });
        } else {
            $("body .cards-with-icon .grid-outer .column-wrap .content-wrap .content").hover(
                function () {
                    $(this).removeClass("show-content");
                    $(this).addClass("show-content");
                },
                function () {
                    $(this).removeClass("show-content");
                }
            );
        }
    });
    $(window).resize(function () {
        var window_width = $(window).width();
        if ($("html").hasClass("ua-mobile")) {
            $("body .cards-with-icon .grid-outer .column-wrap .content-wrap .content").unbind().click(function () {

                if ($("body .cards-with-icon .grid-outer .column-wrap .content-wrap .content").hasClass("show-content")) {
                    $("body .cards-with-icon .grid-outer .column-wrap .content-wrap .content").removeClass("show-content");
                    $("body .cards-with-icon .grid-outer .column-wrap .content-wrap").css({'z-index': '0'});
                } else {
                    $(this).toggleClass("show-content");
                    $(this).parent('.content-wrap').css({'position': 'relative;', 'z-index': '99'});


                }
            });
        } else {
            $("body .cards-with-icon .grid-outer .column-wrap .content-wrap .content").hover(
                function () {
                    $(this).find(".show h4").removeClass("wow fadeInUp").removeAttr("style");
                    $(this).removeClass("show-content");
                    $(this).addClass("show-content");
                },
                function () {
                    $(this).removeClass("show-content");
                }
            );
        }
    });

})(jQuery);